var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _circle, _circle2, _circle3, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _g, _path150, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 386,
    height: 198,
    viewBox: "0 0 386 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11046_1165)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11046_1165)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 382,
    height: 194,
    rx: 24,
    fill: "#0E5A91"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M199.613 140.627C118.736 144.733 119.31 197.882 113 228.046V256.682L477.807 271L484.116 64.2459C496.162 1.24598 381.824 -33.0113 338.423 7.54598C293.683 49.355 301.139 135.472 199.613 140.627Z",
    fill: "#628EB3"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M277.919 175.25H258.464V197.668H277.919V175.25Z",
    fill: "#463332"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M277.919 179.965H258.464V186.99H277.919V179.965Z",
    fill: "#463332"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M336.023 70H200.342C196.287 70 193 73.2872 193 77.3421V172.436C193 176.491 196.287 179.778 200.342 179.778H336.023C340.078 179.778 343.365 176.491 343.365 172.436V77.3421C343.365 73.2872 340.078 70 336.023 70Z",
    fill: "url(#paint0_linear_11046_1165)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M193 166.492V172.698C193 176.946 196.28 180.394 200.342 180.394H336.023C340.085 180.394 343.365 176.946 343.365 172.698V166.492H193Z",
    fill: "url(#paint1_linear_11046_1165)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M333.269 72.2656H203.428C199.546 72.2656 196.399 75.4364 196.399 79.3478V155.828C196.399 159.74 199.546 162.91 203.428 162.91H333.269C337.151 162.91 340.298 159.74 340.298 155.828V79.3478C340.298 75.4364 337.151 72.2656 333.269 72.2656Z",
    fill: "url(#paint2_linear_11046_1165)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M196.399 78.2656C196.399 74.9519 199.085 72.2656 202.399 72.2656H334.298C337.611 72.2656 340.298 74.9519 340.298 78.2656V82.4632H196.399V78.2656Z",
    fill: "url(#paint3_linear_11046_1165)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 199.798,
    y: 88.1289,
    width: 13.5967,
    height: 4.53224,
    fill: "#DDC8BA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 214.528,
    y: 88.1289,
    width: 13.5967,
    height: 4.53224,
    fill: "#DDC8BA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 313.104,
    y: 88.1289,
    width: 7.93141,
    height: 3.39918,
    rx: 1.5,
    fill: "#FFB183"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 323.302,
    y: 88.1289,
    width: 13.5967,
    height: 3.39918,
    rx: 1.5,
    fill: "#D4F7E2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 199.798,
    y: 94.9277,
    width: 44.1893,
    height: 7.93141,
    rx: 2,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 199.798,
    y: 105.125,
    width: 44.1893,
    height: 24.9273,
    rx: 2,
    fill: "#FFE1D1"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 203.198,
    y: 109.656,
    width: 6.79835,
    height: 6.79835,
    rx: 3.39918,
    fill: "url(#paint4_linear_11046_1165)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 203.198,
    y: 119.855,
    width: 35.1248,
    height: 2.26612,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 199.798,
    y: 132.318,
    width: 44.1893,
    height: 27.1934,
    rx: 2,
    fill: "#F2F2F2"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 247.387,
    y: 132.318,
    width: 44.1893,
    height: 27.1934,
    rx: 2,
    fill: "#F2F2F2"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 293.842,
    y: 132.318,
    width: 44.1893,
    height: 27.1934,
    rx: 2,
    fill: "#F2F2F2"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 247.387,
    y: 94.9277,
    width: 44.1893,
    height: 7.93141,
    rx: 2,
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 294.844,
    y: 94.9277,
    width: 44.1893,
    height: 7.93141,
    rx: 2,
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 205.464,
    y: 136.85,
    width: 6.79835,
    height: 6.79835,
    rx: 3.39918,
    fill: "url(#paint5_linear_11046_1165)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 205.464,
    y: 147.047,
    width: 6.79835,
    height: 6.79835,
    rx: 3.39918,
    fill: "url(#paint6_linear_11046_1165)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 217.927,
    y: 136.85,
    width: 6.79835,
    height: 6.79835,
    rx: 3.39918,
    fill: "url(#paint7_linear_11046_1165)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 217.927,
    y: 147.047,
    width: 6.79835,
    height: 6.79835,
    rx: 3.39918,
    fill: "url(#paint8_linear_11046_1165)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 230.391,
    y: 136.85,
    width: 6.79835,
    height: 6.79835,
    rx: 3.39918,
    fill: "url(#paint9_linear_11046_1165)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 230.391,
    y: 147.047,
    width: 6.79835,
    height: 6.79835,
    rx: 3.39918,
    fill: "url(#paint10_linear_11046_1165)"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 253.052,
    y: 136.85,
    width: 6.79835,
    height: 6.79835,
    rx: 3.39918,
    fill: "url(#paint11_linear_11046_1165)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 253.052,
    y: 147.047,
    width: 6.79835,
    height: 6.79835,
    rx: 3.39918,
    fill: "url(#paint12_linear_11046_1165)"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 265.516,
    y: 136.85,
    width: 6.79835,
    height: 6.79835,
    rx: 3.39918,
    fill: "url(#paint13_linear_11046_1165)"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 265.516,
    y: 147.047,
    width: 6.79835,
    height: 6.79835,
    rx: 3.39918,
    fill: "url(#paint14_linear_11046_1165)"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 277.98,
    y: 136.85,
    width: 6.79835,
    height: 6.79835,
    rx: 3.39918,
    fill: "url(#paint15_linear_11046_1165)"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 277.98,
    y: 147.047,
    width: 6.79835,
    height: 6.79835,
    rx: 3.39918,
    fill: "url(#paint16_linear_11046_1165)"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 299.508,
    y: 137.984,
    width: 6.79835,
    height: 6.79835,
    rx: 3.39918,
    fill: "url(#paint17_linear_11046_1165)"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 299.508,
    y: 148.182,
    width: 6.79835,
    height: 6.79835,
    rx: 3.39918,
    fill: "url(#paint18_linear_11046_1165)"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 311.971,
    y: 137.984,
    width: 6.79835,
    height: 6.79835,
    rx: 3.39918,
    fill: "url(#paint19_linear_11046_1165)"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 311.971,
    y: 148.182,
    width: 6.79835,
    height: 6.79835,
    rx: 3.39918,
    fill: "url(#paint20_linear_11046_1165)"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 324.435,
    y: 137.984,
    width: 6.79835,
    height: 6.79835,
    rx: 3.39918,
    fill: "url(#paint21_linear_11046_1165)"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 324.435,
    y: 148.182,
    width: 6.79835,
    height: 6.79835,
    rx: 3.39918,
    fill: "url(#paint22_linear_11046_1165)"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 247.387,
    y: 105.125,
    width: 44.1893,
    height: 26.0604,
    rx: 2,
    fill: "#FFE1D1"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 250.786,
    y: 108.523,
    width: 6.79835,
    height: 6.79835,
    rx: 3.39918,
    fill: "url(#paint23_linear_11046_1165)"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 250.786,
    y: 116.455,
    width: 35.1248,
    height: 2.26612,
    fill: "white"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 250.786,
    y: 120.988,
    width: 35.1248,
    height: 2.26612,
    fill: "white"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 250.786,
    y: 125.52,
    width: 35.1248,
    height: 2.26612,
    fill: "white"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 294.844,
    y: 105.125,
    width: 44.1893,
    height: 26.0604,
    rx: 2,
    fill: "#FFE1D1"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 298.243,
    y: 108.523,
    width: 6.79835,
    height: 6.79835,
    rx: 3.39918,
    fill: "url(#paint24_linear_11046_1165)"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 298.243,
    y: 116.455,
    width: 35.1248,
    height: 2.26612,
    fill: "white"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 298.243,
    y: 120.988,
    width: 35.1248,
    height: 2.26612,
    fill: "white"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 298.243,
    y: 125.52,
    width: 35.1248,
    height: 2.26612,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 316.503,
    cy: 77.9302,
    r: 2.26612,
    fill: "url(#paint25_linear_11046_1165)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 322.169,
    cy: 77.9302,
    r: 2.26612,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 327.834,
    cy: 77.9302,
    r: 2.26612,
    fill: "url(#paint26_linear_11046_1165)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M338.031 74.4491C336.754 73.1084 334.935 72.2656 332.941 72.2656H203.405C199.534 72.2656 196.399 75.3684 196.399 79.1991V154.145C196.399 155.735 196.941 157.21 197.851 158.378L338.031 74.4491Z",
    fill: "white"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M244.991 194.463H291.374C293.293 194.463 294.858 196.028 294.858 197.948V202.849H241.525V197.948C241.525 196.028 243.091 194.463 245.01 194.463H244.991Z",
    fill: "url(#paint27_linear_11046_1165)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M291.374 194.463H268.378C270.298 194.463 271.863 196.028 271.863 197.948V202.849H294.858V197.948C294.858 196.028 293.293 194.463 291.374 194.463Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M343.365 166.492H193V168.505H343.365V166.492Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M334.681 173.778C334.681 175.362 333.395 176.648 331.811 176.648C330.227 176.648 328.941 175.362 328.941 173.778C328.941 172.194 330.227 170.908 331.811 170.908C333.395 170.908 334.681 172.194 334.681 173.778Z",
    fill: "#463332"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M331.811 175.678C332.861 175.678 333.712 174.827 333.712 173.778C333.712 172.728 332.861 171.877 331.811 171.877C330.761 171.877 329.91 172.728 329.91 173.778C329.91 174.827 330.761 175.678 331.811 175.678Z",
    fill: "url(#paint28_linear_11046_1165)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11046_1165",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 266,
    y: 71,
    width: 140,
    height: 132
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M272.809 71H398.592C402.353 71 405.401 74.0484 405.401 77.8089V195.433C405.401 199.193 402.353 202.242 398.592 202.242H272.809C269.048 202.242 266 199.193 266 195.433V77.8089C266 74.0484 269.048 71 272.809 71Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11046_1165)"
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M372.528 134.693C381.318 140.638 394.413 164.324 396.575 177.978C398.736 191.632 389.676 208.402 389.676 208.402H372.978C372.978 208.402 377.571 189.362 378.112 182.211C378.652 175.06 366.511 162.595 366.511 162.595L372.528 134.693Z",
    fill: "url(#paint29_linear_11046_1165)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M374.185 203.25C374.347 202.529 374.527 201.755 374.707 200.944C374.725 200.854 374.743 200.764 374.761 200.674C375.121 199.035 375.518 197.233 375.896 195.414C375.95 195.198 375.986 194.964 376.04 194.748C376.184 194.081 376.31 193.415 376.436 192.748C376.49 192.478 376.544 192.208 376.599 191.938C376.761 191.091 376.923 190.244 377.067 189.434C377.067 189.398 377.067 189.38 377.067 189.344C377.211 188.515 377.355 187.705 377.481 186.93C377.517 186.714 377.553 186.498 377.589 186.282C377.679 185.723 377.751 185.183 377.823 184.66C377.859 184.462 377.877 184.246 377.913 184.048C378.004 183.382 378.076 182.751 378.112 182.211C378.148 181.706 378.112 181.166 378.022 180.608C378.004 180.463 377.967 180.301 377.949 180.157C377.859 179.689 377.733 179.203 377.571 178.698C377.535 178.608 377.517 178.518 377.481 178.41C377.283 177.834 377.031 177.221 376.761 176.627C376.689 176.465 376.599 176.303 376.526 176.14C376.292 175.654 376.04 175.168 375.77 174.681C375.698 174.537 375.608 174.393 375.536 174.249C375.194 173.655 374.815 173.042 374.437 172.448C374.347 172.304 374.257 172.178 374.167 172.033C372.888 170.106 371.483 168.287 370.24 166.756L374.221 168.413L376.202 158.992C376.689 168.413 384.938 184.606 391.603 184.444C397.926 184.282 396.719 178.86 396.629 178.068C398.718 191.704 389.712 208.365 389.712 208.365H373.014C373.014 208.365 373.518 206.258 374.203 203.214L374.185 203.25Z",
    fill: "#463332"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M285.778 123.003C287.327 122.48 290.317 124.39 290.281 124.354C290.029 126.785 289.56 128.857 288.498 129.884C287.741 129.235 288.209 127.128 287.687 126.767C287.147 126.389 286.75 126.263 286.39 126.389C286.084 126.497 285.201 127.38 284.337 128.407C284.084 128.713 283.814 132.189 282.355 131.685C281.779 131.487 281.581 127.65 282.247 126.767C283.49 125.056 285.021 123.237 285.796 122.985L285.778 123.003Z",
    fill: "url(#paint30_linear_11046_1165)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M285.778 123.003C287.327 122.48 290.317 124.39 290.281 124.354C290.029 126.785 289.56 128.857 288.498 129.884C287.741 129.235 288.209 127.128 287.687 126.767C287.147 126.389 286.75 126.263 286.39 126.389C286.084 126.497 285.201 127.38 284.337 128.407C284.084 128.713 283.814 132.189 282.355 131.685C281.779 131.487 281.581 127.65 282.247 126.767C283.49 125.056 285.021 123.237 285.796 122.985L285.778 123.003Z",
    fill: "#C3694D"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M291.308 166.486C289.597 160.181 288.318 137.971 288.318 137.971L294.622 135.432C294.622 135.432 299.864 152.634 302.62 163.874C302.62 163.874 293.037 172.808 291.326 166.504L291.308 166.486Z",
    fill: "url(#paint31_linear_11046_1165)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M294.622 135.432C293.829 132.028 293.253 125.219 292.334 118.662C291.686 114.069 290.389 111.007 289.831 111.241C288.696 111.727 289.128 114.105 289.669 118.59C289.849 120.049 289.903 122.067 289.921 123.021C289.921 123.021 287.165 121.166 285.688 121.671C284.805 121.959 282.914 124.192 281.707 126.12C281.311 127.11 280.572 129.686 281.004 130.01C281.959 130.713 283.238 128.335 283.616 127.723C284.805 126.588 285.94 125.201 286.3 125.075C287.003 124.823 288.786 126.228 288.93 126.786C289.11 127.435 288.75 128.281 288.083 129.254C286.84 131.073 284.643 132.784 284.445 133.541C285.309 135.558 288.155 137.738 288.75 138.386C291.254 138.783 294.622 135.432 294.622 135.432Z",
    fill: "url(#paint32_linear_11046_1165)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M285.093 134.675C284.247 133.414 283.364 131.559 282.301 129.632C281.13 127.542 279.869 125.939 280.086 125.237C280.5 123.868 282.842 125.381 284.535 127.596C286.318 129.938 287.921 129.325 287.921 129.325C287.921 129.325 288.642 132.334 287.849 134.135C287.057 135.936 285.111 134.675 285.111 134.675H285.093Z",
    fill: "url(#paint33_linear_11046_1165)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M285.093 134.675C285.093 134.657 285.057 134.639 285.057 134.603C284.895 134.369 284.733 134.135 284.607 133.883C283.905 132.694 283.166 131.181 282.301 129.631C282.301 129.631 282.301 129.613 282.301 129.595L281.203 127.74C280.5 126.587 279.96 125.705 280.122 125.236C280.212 124.966 280.356 124.822 280.572 124.75C280.626 125.813 282.446 127.92 283.616 129.866C285.021 132.189 287.021 135.72 290.389 137.611L291.92 145.285L288.876 145.411C288.57 141.088 288.39 137.971 288.39 137.971C287.597 137.269 286.12 136.008 285.165 134.675H285.093Z",
    fill: "#C3694D"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M328.018 134.514C321.84 138.098 306.907 164.775 306.907 164.775L297 138.603L286.066 145.087C286.066 145.087 287.94 186.481 306.259 187.976C320.237 189.111 329.675 166.198 329.675 166.198L328.018 134.532V134.514Z",
    fill: "url(#paint34_linear_11046_1165)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M288.588 143.574C289.561 154.256 294.226 184.067 307.664 184.283C319.588 184.481 323.911 162.722 323.911 162.722L328.18 169.333C325.028 175.565 316.994 188.84 306.259 187.976C287.922 186.481 286.066 145.087 286.066 145.087L288.588 143.592V143.574Z",
    fill: "#463332"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M358.802 126.282C357.919 124.751 345.797 124.156 342.825 127.399C339.852 130.641 348.643 133.343 348.643 133.343C348.643 133.343 360.585 129.344 358.802 126.282Z",
    fill: "#EDD3BE"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M340.249 129.903C340.249 129.903 331.638 131.903 328.486 134.19C325.154 136.604 323.551 145.682 323.533 157.913C323.497 173.782 325.694 194.515 324.451 208.385H375.067C375.067 208.385 374.275 184.77 375.752 165.316C377.463 142.656 375.266 138.081 373.338 135.451C371.411 132.821 360.819 130.876 360.819 130.876L340.249 129.867V129.903Z",
    fill: "url(#paint35_linear_11046_1165)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M357.307 119.942C357.307 119.942 364.296 116.231 365.449 104.829C366.547 93.8951 364.746 91.3012 360.945 89.3198C358.099 87.8247 351.146 93.0485 351.146 93.0485L357.307 119.96V119.942Z",
    fill: "url(#paint36_linear_11046_1165)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M351.795 95.3363C351.795 95.3363 356.766 98.7587 362.188 96.6873C364.62 95.7506 364.566 93.5891 363.845 91.5176C365.575 93.6611 366.223 97.2276 365.449 104.811C364.296 116.213 357.307 119.924 357.307 119.924L351.795 95.8407V95.3183V95.3363Z",
    fill: "#491D17"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M359.595 113.385C359.595 113.385 356.334 123.436 358.676 130.353C359.198 132.082 347.112 131.65 342.518 129.632C342.518 129.632 343.725 128.66 343.905 123.652C343.995 121.364 359.577 113.385 359.577 113.385H359.595Z",
    fill: "url(#paint37_linear_11046_1165)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M342.698 129.451C342.698 129.451 342.176 129.595 340.915 129.793C340.915 129.793 340.915 134.891 348.12 135.558C356.784 136.368 360.945 131 360.945 131L357.541 130.154L342.698 129.451Z",
    fill: "url(#paint38_linear_11046_1165)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M354.659 134.91C348.445 132.695 344.788 129.272 343.401 127.741C343.635 126.84 343.851 125.525 343.923 123.652C344.013 121.364 359.594 113.385 359.594 113.385C359.594 113.385 356.334 123.436 358.676 130.353L360.945 131.001C360.945 131.001 358.892 133.541 354.641 134.892L354.659 134.91Z",
    fill: "#AC6B53"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M359.63 106.126C362.368 105.567 363.827 109.08 362.963 111.259C362.08 113.511 359.558 114.808 357.577 114.484C356.64 113.241 357.847 106.936 359.63 106.126Z",
    fill: "url(#paint39_linear_11046_1165)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M359.811 108.342C361.288 108.162 361.936 110.035 361.414 111.134C360.873 112.269 359.504 112.845 358.46 112.593C358.28 112.359 359.162 108.558 359.811 108.342Z",
    fill: "#E48665"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M359.63 106.126C362.368 105.567 363.827 109.08 362.963 111.259C362.08 113.511 359.558 114.808 357.577 114.484C356.64 113.241 357.847 106.936 359.63 106.126Z",
    fill: "#E48665"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M358.154 104.037C357.937 99.1374 356.046 94.0398 348.463 92.2565C340.015 90.2751 334.647 94.0938 333.62 99.6598C333.278 101.479 333.314 105.64 334.323 112.611C335.295 119.294 337.385 127.327 344.554 127.832C347.508 128.03 355.848 126.553 357.505 114.773C357.505 114.773 358.514 112.017 358.172 104.037H358.154Z",
    fill: "url(#paint40_linear_11046_1165)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M354.191 115.276C355.091 104.666 352.731 96.002 352.731 96.002L356.892 98.3977C357.739 100.163 358.081 102.126 358.153 104.036C358.514 111.997 357.487 114.771 357.487 114.771C355.812 126.552 347.49 128.047 344.536 127.831C348.48 127.218 353.452 123.976 354.191 115.276Z",
    fill: "#E48665"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M348.336 92.9037C357.487 96.6144 354.839 110.088 356.965 110.268C358.189 110.376 359.126 107.206 359.108 104.648C359.09 101.262 358.424 96.074 355.704 93.7323C354.623 92.7957 349.435 92.4534 348.336 92.9037Z",
    fill: "url(#paint41_linear_11046_1165)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M354.172 98.7944C354.172 98.7944 351.344 91.0308 341.149 92.5799C332.989 93.8048 333.476 102.469 333.476 102.469C330.215 100.578 328.702 90.7426 332.161 86.4195C335.961 81.6822 333.692 89.3917 341.239 85.5189C350.426 80.8356 360.495 83.1232 361.792 90.1842L354.172 98.7944Z",
    fill: "url(#paint42_linear_11046_1165)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M357.973 97.3358C358.838 99.7675 359.09 102.397 359.108 104.649C359.126 107.207 358.189 110.359 356.965 110.269C355.199 110.125 356.748 100.758 352.011 95.4805C352.677 95.8768 354.533 97.3358 357.973 97.3538V97.3358Z",
    fill: "#491D17"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M350.39 132.261L348.426 135.63L347.021 132.081L342.933 133.847L340.357 129.848L337.259 130.676C338.736 138.998 341.798 149.302 347.13 154.471C357.019 147.248 361.36 138.188 363.936 131.613C362.999 131.325 361.99 131.109 360.927 130.928L350.39 132.279V132.261Z",
    fill: "#EDD3BE"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M361.486 130.947C361.486 130.947 360.549 136.855 352.065 140.674L350.228 132.262L361.486 130.947Z",
    fill: "#ECD2BD"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M347.057 139.035L350.011 139.125L351.506 152.995C350.101 154.292 348.588 155.535 346.931 156.76C345.994 155.859 345.13 154.814 344.319 153.662L347.057 139.053V139.035Z",
    fill: "url(#paint43_linear_11046_1165)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M345.977 155.733C345.4 155.084 344.842 154.4 344.319 153.661L347.057 139.053L350.012 139.143L350.192 140.854C348.3 141.575 346.283 147.861 345.977 155.751V155.733Z",
    fill: "#822E50"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M352.858 132.73C352.858 132.73 351.038 135.216 348.607 135.036C346.175 134.856 344.608 132.821 344.608 132.821L343.563 134.73C343.563 134.73 345.22 137.288 348.336 137.378C351.471 137.468 353.722 134.82 353.722 134.82L352.858 132.73Z",
    fill: "url(#paint44_linear_11046_1165)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M352.858 132.73C352.858 132.73 351.038 135.216 348.607 135.036C346.175 134.856 344.608 132.821 344.608 132.821L343.563 134.73C343.563 134.73 345.22 137.288 348.336 137.378C351.471 137.468 353.722 134.82 353.722 134.82L352.858 132.73Z",
    fill: "#822E50"
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M350.984 134.478C350.48 133.937 346.733 133.901 346.301 134.478C345.85 135.054 346.661 138.801 346.913 139.071C347.165 139.341 349.867 139.395 350.156 139.161C350.444 138.909 351.488 135.036 350.984 134.496V134.478Z",
    fill: "url(#paint45_linear_11046_1165)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M346.301 134.478C346.463 134.262 347.075 134.136 347.814 134.082C347.543 134.46 347.363 134.911 347.363 135.415C347.363 136.712 348.372 137.739 349.633 137.739C350.047 137.739 350.426 137.595 350.768 137.378C350.552 138.261 350.299 139.018 350.173 139.126C349.885 139.378 347.201 139.306 346.931 139.036C346.661 138.765 345.868 135.019 346.319 134.442L346.301 134.478Z",
    fill: "#822E50"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M347.075 132.226L345.256 140.656C345.256 140.656 339.42 136.531 340.176 130.082L347.075 132.226Z",
    fill: "#ECD2BD"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M358.802 126.281C358.802 126.281 356.28 130.784 350.372 132.28L352.371 138.89C356.478 137.413 360.279 133.865 361.486 130.965L358.802 126.299V126.281Z",
    fill: "#FFE6D6"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M347.003 132.083L345.112 138.873C345.112 138.873 339.798 133.29 340.213 129.705L342.734 127.525C342.734 127.525 343.653 130.317 346.985 132.083H347.003Z",
    fill: "#FFE6D6"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M332.161 86.4187C333.206 85.1218 333.782 84.7795 334.232 84.8516C332.107 85.8062 330.972 91.2641 333.17 91.8225C335.115 92.3089 335.529 90.1113 339.258 89.3007C345.382 87.9678 351.201 94.9928 356.821 92.2188C360.657 90.3275 359.667 86.7789 357.721 84.6895C359.865 85.8963 361.378 87.7516 361.828 90.2014C360.603 92.7052 357.901 94.6325 351.543 95.1549C349.561 93.3897 346.301 91.8225 341.167 92.5971C333.008 93.822 333.494 102.486 333.494 102.486C330.234 100.595 328.721 90.7598 332.179 86.4367L332.161 86.4187Z",
    fill: "#491D17"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M346.427 112.465C347.634 112.465 348.768 111.997 349.633 111.132C350.498 110.286 350.966 109.133 350.966 107.926C350.966 106.719 350.498 105.584 349.633 104.72C348.786 103.855 347.652 103.387 346.427 103.387C343.923 103.387 341.906 105.422 341.887 107.908C341.887 109.115 342.356 110.25 343.22 111.114C344.067 111.979 345.22 112.447 346.427 112.447V112.465ZM346.427 104.089C347.453 104.089 348.408 104.486 349.147 105.224C349.867 105.945 350.263 106.917 350.263 107.944C350.263 108.971 349.867 109.925 349.129 110.664C348.408 111.384 347.435 111.781 346.427 111.781C345.4 111.781 344.445 111.384 343.707 110.646C342.986 109.925 342.59 108.953 342.59 107.926C342.59 105.8 344.319 104.089 346.427 104.089Z",
    fill: "#423333"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M335.818 113.637C335.98 113.637 336.16 113.637 336.34 113.601C338.321 113.277 339.6 111.079 339.222 108.719C338.826 106.36 336.916 104.703 334.917 105.045C332.936 105.369 331.657 107.567 332.035 109.926C332.215 111.061 332.773 112.07 333.566 112.754C334.232 113.331 335.025 113.637 335.818 113.637ZM335.421 105.693C336.88 105.693 338.231 107.026 338.538 108.827C338.862 110.809 337.835 112.646 336.232 112.916C335.475 113.042 334.683 112.79 334.034 112.232C333.368 111.637 332.9 110.791 332.737 109.818C332.413 107.837 333.44 105.999 335.043 105.729C335.169 105.711 335.313 105.693 335.439 105.693H335.421Z",
    fill: "#423333"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M350.588 107.836C350.588 107.836 350.606 107.836 350.624 107.836L359.054 106.863C359.234 106.845 359.36 106.683 359.342 106.485C359.324 106.305 359.162 106.179 358.964 106.197L350.534 107.17C350.354 107.188 350.228 107.35 350.246 107.548C350.264 107.71 350.408 107.836 350.57 107.836H350.588Z",
    fill: "#423333"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M339.096 109.422C339.186 109.422 339.276 109.386 339.348 109.296C340.519 107.8 342.068 108.791 342.122 108.827C342.266 108.917 342.464 108.881 342.554 108.737C342.644 108.593 342.608 108.395 342.464 108.305C341.744 107.836 340.068 107.368 338.843 108.917C338.735 109.061 338.753 109.241 338.897 109.35C338.952 109.386 339.024 109.422 339.096 109.422Z",
    fill: "#423333"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M347.778 156.309L342.086 158.146C338.375 155.625 334.16 151.392 333.836 150.005C333.458 148.383 335.331 145.88 335.331 145.88C335.331 145.88 331.963 145.754 330.954 144.132C330.251 142.98 330.576 136.585 330.846 132.928C332.665 132.118 334.863 131.397 336.682 130.875C338.844 141.935 342.302 150.599 347.76 156.327L347.778 156.309Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M323.569 162.127C329.747 167.999 339.654 169.765 350.57 168.99C361.558 168.197 370.942 165.009 376.202 158.236C376.094 160.38 375.968 162.722 375.77 165.333C374.293 184.787 375.085 208.402 375.085 208.402H324.469C325.604 195.703 323.839 177.312 323.587 162.127H323.569Z",
    fill: "#463332"
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M296.333 138.945L286.751 144.727L286.498 141.214L295.469 136.459L296.333 138.945Z",
    fill: "#EDD3BE"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M342.212 159.767C342.05 158.867 341.96 158.308 341.96 158.308L342.41 157.984C349.615 156.489 363.683 142.835 364.782 131.775C366.313 132.154 368.06 132.658 369.61 133.252C369.718 135.54 369.844 143.736 366.223 147.861L361.378 148.203C361.378 148.203 363.215 151.734 362.747 152.652C362.278 153.571 351.489 160.758 342.212 159.749V159.767Z",
    fill: "#463332"
  }))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M363.972 131.199L368.313 132.514C368.313 132.514 369.159 142.421 365.124 147.014L360.441 147.591C360.441 147.591 362.278 150.707 361.828 151.59C361.378 152.472 350.858 159.479 341.96 158.327L347.166 154.526C355.073 148.167 360.873 140.548 363.954 131.199H363.972Z",
    fill: "#665050"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M337.132 130.281L332.665 132.047C332.665 132.047 331.729 142.548 332.593 143.971C333.458 145.376 336.394 145.484 336.394 145.484C336.394 145.484 334.773 147.646 335.097 149.069C335.421 150.474 340.357 155.247 343.815 157.084L347.184 154.545C342.086 149.213 338.988 140.945 337.15 130.299L337.132 130.281Z",
    fill: "#665050"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M347.148 154.526L341.96 158.326C341.96 158.326 344.194 178.05 344.248 189.597C344.302 201.143 343.779 208.294 343.779 208.294H342.644C342.644 208.294 343.293 195.775 343.275 189.759C343.275 183.742 340.897 157.462 340.897 157.462L346.355 153.625L347.148 154.526Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M352.371 183.833C351.177 183.833 350.21 182.865 350.21 181.671C350.21 180.478 351.177 179.51 352.371 179.51C353.565 179.51 354.533 180.478 354.533 181.671C354.533 182.865 353.565 183.833 352.371 183.833Z",
    fill: "#463332"
  }))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M350.804 181.383C350.804 182.41 351.633 183.256 352.678 183.256C353.722 183.256 354.551 182.428 354.551 181.383C354.551 180.338 353.722 179.51 352.678 179.51C351.633 179.51 350.804 180.338 350.804 181.383Z",
    fill: "#665050"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M352.641 197.973C351.448 197.973 350.48 197.006 350.48 195.812C350.48 194.618 351.448 193.65 352.641 193.65C353.835 193.65 354.803 194.618 354.803 195.812C354.803 197.006 353.835 197.973 352.641 197.973Z",
    fill: "#463332"
  }))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M351.056 195.524C351.056 196.55 351.885 197.397 352.93 197.397C353.974 197.397 354.803 196.568 354.803 195.524C354.803 194.479 353.974 193.65 352.93 193.65C351.885 193.65 351.056 194.479 351.056 195.524Z",
    fill: "#665050"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M371.393 170.881L356.821 170.917L356.766 161.622L371.339 161.586L371.393 170.881Z",
    fill: "#463332"
  }))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M370.204 169.674L356.694 169.728L356.658 161.677L370.15 161.641L370.204 169.674Z",
    fill: "#FFE6D6"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M365.485 159.713L361.306 159.731L361.324 161.658L365.485 161.64V159.713Z",
    fill: "#847070"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M369.321 168.557H364.692L364.656 162.721L369.285 162.703L369.321 168.557Z",
    fill: "#DDC4B6"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M363.899 166.035L357.595 166.053V164.756L363.899 164.738V166.035Z",
    fill: "#DDC4B6"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M363.899 163.964L357.595 163.982L357.577 162.739L363.881 162.721L363.899 163.964Z",
    fill: "#DDC4B6"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M363.918 167.422L357.613 167.44L357.595 166.774L363.9 166.756L363.918 167.422Z",
    fill: "#DDC4B6"
  }))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M226.17 243.376H173.906C150.847 231.525 145.843 152.544 176.13 145.58C206.418 138.615 210.924 180.081 220.903 184.09C229.067 187.367 239.163 187.63 241.943 197.785C244.723 207.968 243.318 232.783 226.141 243.376H226.17Z",
    fill: "url(#paint46_linear_11046_1165)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M176.277 145.58C176.277 145.58 176.365 145.58 176.423 145.551C167.79 154.652 162.406 167.586 162.406 181.925C162.406 209.432 182.217 231.73 206.652 231.73C221.81 231.73 235.212 223.156 243.172 210.046C242.645 221.517 238.373 235.944 226.316 243.377H174.053C150.994 231.525 145.785 152.779 176.277 145.58Z",
    fill: "#AA2424"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M188.567 148.594C208.554 148.594 211.977 180.49 220.932 184.09C225.38 185.875 230.413 186.753 234.51 188.83C234.451 189.825 234.276 190.615 233.925 191.171C228.657 199.775 229.213 206.739 229.213 206.739H186.899C177.096 206.739 170.629 192.927 170.805 178.764C170.98 163.869 176.716 148.594 188.596 148.594H188.567Z",
    fill: "#AA2424"
  }))), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M183.095 128.431C183.095 136.596 179.203 143.385 180.871 150.349C182.07 155.382 187.806 156.172 187.806 156.172C187.806 156.172 210.016 158.396 211.275 149.091C212.533 139.785 206.593 135.484 206.037 127.992C205.481 120.501 183.095 123.895 183.095 128.46V128.431Z",
    fill: "url(#paint47_linear_11046_1165)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M183.095 128.431C183.095 136.596 179.203 143.385 180.871 150.349C182.07 155.382 187.806 156.172 187.806 156.172C187.806 156.172 210.016 158.396 211.275 149.091C212.533 139.785 206.593 135.484 206.037 127.992C205.481 120.501 183.095 123.895 183.095 128.46V128.431Z",
    fill: "#491D17"
  }))), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M232.198 190.879C230.237 190.236 213.996 187.895 213.996 187.895L209.9 189.797L213.119 206.798H230.559L232.198 190.909V190.879Z",
    fill: "url(#paint48_linear_11046_1165)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M240.216 201.677C244.079 216.426 250.868 239.221 250.868 239.221C248.761 239.924 246.566 240.304 244.108 239.221C244.108 239.221 237.729 228.453 231.7 213.031C229.008 206.183 224.794 195.444 228.92 191.669C231.759 189.065 237.641 191.903 240.216 201.677Z",
    fill: "url(#paint49_linear_11046_1165)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M209.988 190.294L210.397 189.533L213.967 187.895C213.967 187.895 228.891 190.031 231.847 190.792C234.042 191.084 236.588 193.103 238.519 197.083C237.495 195.913 235.856 193.981 233.749 194.684C229.652 196.059 231.291 208.993 235.476 218.796C239.163 227.487 246.625 237.642 248.293 239.836C246.976 240.012 245.571 239.895 244.108 239.222C244.108 239.222 237.729 228.453 231.701 213.031C230.969 211.159 230.12 209.022 229.36 206.769H215.138L212.007 201.004L209.958 190.294H209.988Z",
    fill: "#334B72"
  }))), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M182.656 188.888H205.569L205.51 188.215C205.51 188.215 218.562 190 220.464 191.346L213.997 206.768H186.841C181.837 202.934 180.929 194.389 182.627 188.888H182.656Z",
    fill: "url(#paint50_linear_11046_1165)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M225.584 201.822C226.55 218.97 229.008 239.22 229.008 239.22C226.872 240.186 224.326 240.332 222.248 239.22C222.248 239.22 217.391 228.451 214.611 212.942C213.235 205.246 211.275 195.94 215.723 192.077C219.293 188.976 225.028 191.609 225.584 201.822Z",
    fill: "url(#paint51_linear_11046_1165)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M182.656 188.888H205.568L205.51 188.215C205.51 188.215 216.308 189.707 219.702 190.966C222.512 191.58 225.204 195.004 225.584 201.822C225.672 203.402 225.76 205.012 225.877 206.65V206.738C225.175 200.213 225.175 194.302 218.766 194.097C209.87 193.833 198.897 195.852 198.897 199.481C198.897 203.11 214.464 202.583 216.132 203.958C217.771 205.334 214.962 223.389 225.497 239.981C224.385 239.981 223.273 239.747 222.248 239.22C222.248 239.22 217.391 228.451 214.611 212.942C214.26 210.952 213.85 208.845 213.557 206.768H186.899C181.895 202.934 180.988 194.389 182.685 188.888H182.656Z",
    fill: "#334B72"
  }))), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M225.906 164.689C227.311 161.733 229.184 151.93 229.623 150.467C230.15 148.594 226.316 149.033 226.316 149.033C226.053 150.496 222.951 157.139 220.61 162.406C220.61 162.406 224.531 167.644 225.936 164.689H225.906Z",
    fill: "url(#paint52_linear_11046_1165)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M226.287 149.033C226.784 146.721 228.394 142.917 229.974 142.8C230.91 142.741 232.139 145.814 231.817 146.633C231.174 148.33 230.032 149.472 229.681 150.32C229.33 151.198 226.287 149.033 226.287 149.033Z",
    fill: "url(#paint53_linear_11046_1165)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M197.316 146.984C202.964 160.27 210.163 176.072 217.508 177.242C222.336 178.003 228.277 174.696 229.623 154.3L224.092 149.881L217.947 166.122C215.547 165.83 213.323 151.169 208.758 146.545C206.739 144.497 197.316 146.984 197.316 146.984Z",
    fill: "url(#paint54_linear_11046_1165)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M205.773 149.881C209.226 167.468 215.635 173.526 218.269 173.614C222.921 173.76 227.369 170.6 229.623 154.3C228.277 174.696 222.336 178.003 217.508 177.242C210.163 176.072 202.964 160.27 197.316 146.984C197.316 146.984 205.071 150.057 205.773 149.881Z",
    fill: "#A0335D"
  }))), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M201.589 111.225C201.589 111.225 203.813 109.791 206.593 111.957C210.397 114.912 208.641 119.39 209.168 122.55L202.877 115.732L201.589 111.196V111.225Z",
    fill: "url(#paint55_linear_11046_1165)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M202.877 115.759L209.168 122.578C208.788 120.383 209.519 117.544 208.759 115.057C208.29 115.408 207.617 115.379 206.3 114.501C204.925 113.565 203.784 112.102 203.784 112.102L202.408 114.121L202.877 115.789V115.759Z",
    fill: "#491D17"
  }))), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M182.392 189.678C185.67 179.787 191.318 177.3 190.849 170.423C190.498 165.331 183.504 158.894 185.758 149.705C187.484 142.711 194.156 142.916 200.009 142.74C202.35 142.682 204.72 143.238 206.681 144.526C211.041 147.423 214.523 156.523 213.411 160.474C212.27 164.541 209.636 164.775 209.636 170.833C209.636 175.895 212.124 180.841 213.996 188.098C214.318 190.849 192.986 195.589 182.392 189.678Z",
    fill: "url(#paint56_linear_11046_1165)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M190.85 170.423C190.499 165.331 183.505 158.893 185.758 149.705C186.138 148.212 186.724 147.071 187.485 146.164C187.104 149.471 187.777 152.982 189.621 156.113C194.8 164.834 210.193 167.965 213.558 159.362C213.529 159.771 213.47 160.152 213.382 160.503C212.241 164.57 209.607 164.805 209.607 170.862C209.607 175.924 212.095 180.87 213.968 188.127C214.289 190.878 192.957 195.618 182.364 189.707C185.641 179.816 191.289 177.329 190.821 170.452L190.85 170.423Z",
    fill: "#A0335D"
  }))), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M192.927 143.267L191.727 143.56C192.839 146.72 197.024 151.783 202.525 151.08C207.002 150.524 206.183 146.223 204.895 143.56L203.403 142.945L192.927 143.238V143.267Z",
    fill: "url(#paint57_linear_11046_1165)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M193.688 129.396C194.302 131.972 194.507 134.108 194.712 137.122C195.005 141.365 192.781 143.443 192.781 143.443C195.502 144.145 200.506 144.438 203.432 142.974C203.432 142.974 201.179 142.418 202.057 136.624C202.642 132.645 193.717 129.396 193.717 129.396H193.688Z",
    fill: "url(#paint58_linear_11046_1165)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M197.521 150.145C195.414 149.062 193.747 147.248 192.722 145.55C192.371 144.965 192.108 144.438 191.903 143.941C191.903 143.941 191.815 143.707 191.757 143.59L192.956 143.297C192.956 143.297 193.22 142.975 193.395 142.741C193.395 142.741 193.395 142.741 193.395 142.712C193.981 141.805 194.8 140.137 194.712 137.649C194.712 137.503 194.712 137.328 194.712 137.181C194.712 137.035 194.712 136.918 194.712 136.801C194.566 134.899 194.42 133.318 194.156 131.738L201.911 135.425C202.057 135.835 202.116 136.274 202.057 136.684C201.209 142.507 203.433 143.034 203.433 143.034L203.754 143.18C202.935 144.643 200.799 148.038 197.521 150.203V150.145Z",
    fill: "#AC6B53"
  }))), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M194.068 134.607C197.667 139.728 204.281 140.46 205.247 140.167C206.212 139.874 211.772 133.378 209.548 126.15C209.285 125.184 209.051 120.239 207.792 118.161C204.691 113.04 200.36 112.982 196.234 114.445C189.737 116.757 189.532 122.668 191.698 129.105C191.698 129.105 192.517 132.412 194.068 134.607Z",
    fill: "url(#paint59_linear_11046_1165)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M193.746 124.422L191.259 127.582C191.405 128.08 191.522 128.606 191.698 129.133C191.698 129.133 192.517 132.44 194.068 134.635C197.668 139.756 204.281 140.487 205.247 140.195C194.127 138.966 193.746 124.422 193.746 124.422Z",
    fill: "#E38565"
  }))), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M191.347 127.437C189.386 127.203 188.479 129.72 189.182 131.183C189.913 132.704 191.903 133.465 193.278 133.143C193.893 132.236 192.635 127.905 191.347 127.437Z",
    fill: "url(#paint60_linear_11046_1165)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M191.347 127.437C189.386 127.203 188.479 129.72 189.182 131.183C189.913 132.704 191.903 133.495 193.278 133.173C193.893 132.266 192.635 127.905 191.318 127.437H191.347Z",
    fill: "#E38565"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M191.288 128.988C190.235 128.93 189.855 130.276 190.264 131.007C190.703 131.768 191.698 132.09 192.43 131.885C192.547 131.71 191.932 130.802 191.288 128.988Z",
    fill: "#AC6B53"
  }))), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M193.424 126.646C193.366 128.168 193.746 129.485 192.605 129.748C191.464 129.982 190.79 127.407 190.79 127.407L193.424 126.676V126.646Z",
    fill: "url(#paint61_linear_11046_1165)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M204.369 113.654C204.632 117.077 199.482 118.892 196.966 120.618C193.074 123.281 193.425 127.758 193.425 127.758L190.937 127.349C190.937 127.349 184.646 128.9 183.095 128.461C182.129 118.687 184.88 112.454 193.542 109.732C200.828 107.45 204.164 110.991 204.369 113.683V113.654Z",
    fill: "url(#paint62_linear_11046_1165)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M230.854 149.502C230.999 149.734 231.086 149.734 231.028 149.502H230.854Z",
    fill: "#7E8082"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M230.823 149.501C230.296 149.033 228.833 146.429 227.224 143.151C225.409 139.435 223.975 136.392 224.473 136.157C224.97 135.923 226.463 138.908 228.277 142.654C229.887 145.961 230.969 148.828 231.028 149.531H230.823V149.501Z",
    fill: "url(#paint63_linear_11046_1165)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M226.235 141.066L227.287 140.553L227.634 141.263L226.582 141.776L226.235 141.066Z",
    fill: "url(#paint64_linear_11046_1165)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M230.501 148.448C230.179 148.067 228.833 145.317 227.662 142.888C226.316 140.137 224.882 137.24 225.087 137.123C225.292 137.035 226.785 139.903 228.131 142.654C229.301 145.083 230.501 147.921 230.589 148.389H230.501V148.448Z",
    fill: "#A7AAAF"
  }))), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M226.209 141.038L226.656 140.82L227.002 141.53L226.555 141.749L226.209 141.038Z",
    fill: "#A69B9B"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M230.501 142.742C230.823 143.21 230.354 143.591 229.857 144.029C229.359 144.468 228.833 144.849 228.481 144.498C228.101 144.117 228.657 143.386 229.213 142.917C229.652 142.537 230.149 142.244 230.501 142.742Z",
    fill: "#FFB182"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M231.817 144.264C232.169 144.673 231.7 145.288 231.144 145.932C230.588 146.605 229.857 147.336 229.476 146.956C229.125 146.575 229.74 145.727 230.354 145.025C230.881 144.41 231.437 143.854 231.817 144.264Z",
    fill: "#FFB182"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M232.051 145.433C232.315 145.755 232.022 146.34 231.613 146.867C231.174 147.423 230.588 147.95 230.237 147.745C229.857 147.511 230.383 146.75 230.852 146.165C231.232 145.667 231.73 145.023 232.081 145.462L232.051 145.433Z",
    fill: "#FFB182"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M231.32 143.473C231.642 143.941 231.233 144.38 230.735 144.936C230.179 145.55 229.565 146.077 229.096 145.755C228.599 145.433 229.272 144.526 229.916 143.912C230.443 143.385 230.999 142.975 231.35 143.443L231.32 143.473Z",
    fill: "#FFB182"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M207.002 179.875C208.202 179.934 211.362 180.168 212.884 180.372C214.406 180.577 217.186 181.923 217.098 182.538C217.01 183.182 214.933 181.719 213.235 181.455C211.538 181.192 207.002 179.875 207.002 179.875Z",
    fill: "url(#paint65_linear_11046_1165)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M205.89 183.095C207.002 183.768 208.67 184.119 210.748 184.47C213.908 185.026 214.581 186.138 214.991 185.494C215.371 184.909 211.714 183.826 211.86 183.592C211.977 183.358 213.382 183.768 214.464 184.207C215.84 184.734 217.156 185.465 217.361 185.026C217.566 184.587 216.63 184.207 215.137 183.475C213.733 182.773 212.562 182.568 212.562 182.305C212.562 182.041 214.172 182.744 215.488 183.241C216.6 183.651 217.8 184.675 218.151 184.178C218.386 183.826 217.01 182.978 215.606 182.275C213.177 181.046 211.245 180.373 208.992 180.052C208.026 179.905 207.031 179.876 207.031 179.876C207.031 179.876 207.031 179.525 206.3 181.076C205.539 182.627 205.919 183.095 205.919 183.095H205.89Z",
    fill: "url(#paint66_linear_11046_1165)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M207.003 179.876C205.744 179.759 202.086 178.705 202.086 178.705L200.565 182.451C200.565 182.451 204.574 182.743 205.861 183.065C207.149 183.387 206.973 179.846 206.973 179.846L207.003 179.876Z",
    fill: "url(#paint67_linear_11046_1165)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M202.115 178.705C202.115 178.705 205.042 179.554 206.563 179.788C206.417 180.49 206.183 182.48 207.968 183.329C209.841 184.236 211.099 184.382 212.065 184.733C211.684 184.645 211.275 184.528 210.806 184.441C208.729 184.06 207.061 183.738 205.949 183.065C204.661 182.743 200.652 182.451 200.652 182.451L202.174 178.705H202.115Z",
    fill: "#C4694D"
  }))), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M226.111 148.857C225.936 147.247 226.258 145.726 226.609 144.672C226.843 143.97 227.399 142.126 227.867 142.214C228.599 142.36 228.16 144.028 227.984 144.76C227.721 145.843 228.686 146.545 228.774 147.452C228.979 150.115 226.345 150.905 226.141 148.857H226.111Z",
    fill: "#FFB182"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M188.391 145.726C184.616 145.55 176.247 171.067 178.998 176.481C182.158 182.685 199.628 184.118 204.106 184.177C204.106 184.177 206.681 181.221 204.749 177.271C204.749 177.271 191.171 172.326 189.767 170.833C188.362 169.341 199.131 146.194 188.421 145.726H188.391Z",
    fill: "url(#paint68_linear_11046_1165)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M239.923 191.639V190.147C239.923 190.147 237.904 188.42 233.222 188.45C228.54 188.45 222.131 188.479 217.683 188.508C213.265 188.508 211.07 189.883 211.07 189.883V191.698L239.923 191.639Z",
    fill: "#CEB6AA"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M222.775 186.255C228.277 186.109 233.895 186.255 238.899 186.635C232.461 186.635 228.218 187.718 226.053 190.381L209.899 190.44C212.884 186.665 222.775 186.255 222.775 186.255Z",
    fill: "#EDD8CA"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M214.962 190.439L215.489 187.396C215.957 187.279 216.455 187.133 216.923 187.045C218.006 187.425 219.761 187.894 222.044 188.069C226.082 188.391 230.706 187.572 230.706 187.572C228.657 188.186 227.106 189.093 226.053 190.41H214.962V190.439Z",
    fill: "#CEB6AA"
  }))), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M196.731 190.497L195.151 190.409V189.912C195.151 189.912 197.316 188.537 201.764 188.537C204.749 188.537 208.641 188.537 212.299 188.507C213.499 188.098 215.576 187.6 218.649 187.688C223.945 187.834 225.643 190.38 225.643 190.38L224.004 190.322V191.697L195.18 191.755V190.673L196.76 190.526L196.731 190.497Z",
    fill: "#CEB6AA"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M196.731 190.497L195.092 190.41V189.912L211.626 189.854V191.697L195.092 191.726V190.644L196.731 190.497Z",
    fill: "#B29B93"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M240.099 191.639V190.147C240.099 190.147 238.08 188.42 233.398 188.45C228.715 188.45 226.082 190.352 226.082 190.352C226.082 190.352 222.307 188.479 217.888 188.508C213.469 188.508 211.275 189.883 211.275 189.883V191.698L240.128 191.639H240.099Z",
    fill: "#FAE7DC"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M210.796 191.671L241.346 191.58L241.349 192.604L210.799 192.695L210.796 191.671Z",
    fill: "url(#paint69_linear_11046_1165)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M193.648 191.721L210.855 191.67L210.858 192.694L193.651 192.745L193.648 191.721Z",
    fill: "url(#paint70_linear_11046_1165)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M226.17 190.499C229.535 186.314 238.811 186.958 238.899 186.958V186.665C238.519 186.636 229.418 186.022 225.965 190.323L226.199 190.499H226.17Z",
    fill: "#FAE7DC"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M224.999 191.61H227.106C227.106 191.61 226.55 190.557 226.053 190.557C225.555 190.557 224.999 191.61 224.999 191.61Z",
    fill: "url(#paint71_linear_11046_1165)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M203.14 186.927C203.14 186.927 204.632 187.103 206.505 187.951L221.722 188.625L225.467 189.824C225.467 189.824 223.156 186.84 215.108 186.313C207.91 185.845 203.111 186.927 203.111 186.927H203.14Z",
    fill: "#CEB6AA"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M211.275 188.918L195.122 188.713C195.122 188.713 197.726 188.04 202.145 187.747C206.563 187.455 217.069 187.045 221.049 188.099C221.049 188.099 216.015 187.338 211.275 188.947V188.918Z",
    fill: "#EDD8CA"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M212.094 186.899L195.941 186.782C195.941 186.782 198.546 186.079 202.964 185.728C206.593 185.435 218.122 184.88 223.243 187.981C223.243 187.981 217.625 185.816 212.065 186.899H212.094Z",
    fill: "#EDD8CA"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M225.848 190.499L226.023 190.265C220.375 185.876 211.772 188.451 211.275 188.626L195.092 188.685V188.977L211.333 188.919C211.333 188.919 220.171 186.11 225.848 190.499Z",
    fill: "#FAE7DC"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M225.818 190.468L226.052 190.293C222.307 185.142 212.211 186.723 212.094 186.723L195.912 186.781V187.074L212.094 187.015C212.094 187.015 222.16 185.435 225.789 190.468H225.818Z",
    fill: "#FAE7DC"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M223.975 190.293C223.975 190.293 223.331 189.972 222.278 189.65C221.224 189.357 219.79 189.094 218.327 189.035C215.401 189.035 212.621 189.942 212.621 189.942C212.621 189.942 215.459 189.181 218.327 189.328C219.761 189.328 221.195 189.474 222.248 189.737C223.302 189.972 223.975 190.293 223.975 190.293Z",
    fill: "#D8C0B6"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M223.127 190.763C223.127 190.763 221.371 190.324 219.586 190.207C217.771 190.207 215.986 190.441 215.986 190.441C215.986 190.441 217.771 190.353 219.556 190.5C221.342 190.5 223.127 190.763 223.127 190.763Z",
    fill: "#D8C0B6"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M227.516 190.323C227.516 190.323 228.218 190.031 229.33 189.767C230.442 189.504 231.935 189.299 233.456 189.328C236.5 189.153 239.426 190.206 239.426 190.206C239.426 190.206 236.558 189.006 233.456 189.036C231.935 189.094 230.413 189.358 229.301 189.679C228.189 189.972 227.516 190.323 227.516 190.323Z",
    fill: "#D8C0B6"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M237.114 190.967C237.114 190.967 234.949 190.47 232.725 190.499C230.501 190.587 228.365 191.172 228.365 191.172C228.365 191.172 230.53 190.733 232.725 190.763C234.92 190.616 237.114 190.938 237.114 190.938V190.967Z",
    fill: "#D8C0B6"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M193.648 191.721L210.855 191.67L210.858 192.694L193.651 192.745L193.648 191.721Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M180.549 174.666C183.592 180.636 199.95 182.187 205.101 182.333C204.691 183.474 204.106 184.147 204.106 184.147C199.658 184.089 182.159 182.655 178.998 176.451C176.482 171.476 183.358 149.412 187.426 146.105C185.846 148.3 178.003 169.633 180.52 174.637L180.549 174.666Z",
    fill: "#A0335D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M185.173 115.644C184.324 117.634 184.412 120.238 187.748 120.999C193.454 122.316 202.438 117.37 202.994 113.303C203.199 111.752 202.877 110.698 201.765 109.908C203.433 110.845 204.281 112.366 204.398 113.654C204.662 117.078 199.511 118.892 196.995 120.618C196.234 121.145 195.561 121.789 195.005 122.55C194.069 123.837 193.571 125.505 193.454 126.822C193.454 128.256 193.717 129.514 192.635 129.719C191.493 129.953 190.82 127.378 190.82 127.378L190.996 127.32C190.791 127.378 184.997 128.783 183.271 128.461C183.212 128.285 183.153 128.08 183.095 127.876C182.656 122.813 183.271 118.746 185.202 115.644H185.173Z",
    fill: "#491D17"
  }))), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M32.14 67.24C31.1133 67.24 30.2067 67.0667 29.42 66.72C28.6333 66.36 28.0133 65.8533 27.56 65.2C27.1067 64.5333 26.8733 63.7267 26.86 62.78H29.56C29.5867 63.4333 29.82 63.9867 30.26 64.44C30.7133 64.88 31.3333 65.1 32.12 65.1C32.8 65.1 33.34 64.94 33.74 64.62C34.14 64.2867 34.34 63.8467 34.34 63.3C34.34 62.7267 34.16 62.28 33.8 61.96C33.4533 61.64 32.9867 61.38 32.4 61.18C31.8133 60.98 31.1867 60.7667 30.52 60.54C29.44 60.1667 28.6133 59.6867 28.04 59.1C27.48 58.5133 27.2 57.7333 27.2 56.76C27.1867 55.9333 27.38 55.2267 27.78 54.64C28.1933 54.04 28.7533 53.58 29.46 53.26C30.1667 52.9267 30.98 52.76 31.9 52.76C32.8333 52.76 33.6533 52.9267 34.36 53.26C35.08 53.5933 35.64 54.06 36.04 54.66C36.4533 55.26 36.6733 55.9733 36.7 56.8H33.96C33.9467 56.3067 33.7533 55.8733 33.38 55.5C33.02 55.1133 32.5133 54.92 31.86 54.92C31.3 54.9067 30.8267 55.0467 30.44 55.34C30.0667 55.62 29.88 56.0333 29.88 56.58C29.88 57.0467 30.0267 57.42 30.32 57.7C30.6133 57.9667 31.0133 58.1933 31.52 58.38C32.0267 58.5667 32.6067 58.7667 33.26 58.98C33.9533 59.22 34.5867 59.5 35.16 59.82C35.7333 60.14 36.1933 60.5667 36.54 61.1C36.8867 61.62 37.06 62.2933 37.06 63.12C37.06 63.8533 36.8733 64.5333 36.5 65.16C36.1267 65.7867 35.5733 66.2933 34.84 66.68C34.1067 67.0533 33.2067 67.24 32.14 67.24ZM43.8736 67.24C42.8603 67.24 41.9669 67.02 41.1936 66.58C40.4203 66.14 39.8069 65.5267 39.3536 64.74C38.9136 63.9533 38.6936 63.0533 38.6936 62.04C38.6936 61.0267 38.9136 60.1267 39.3536 59.34C39.8069 58.5533 40.4203 57.94 41.1936 57.5C41.9669 57.06 42.8603 56.84 43.8736 56.84C45.1403 56.84 46.2069 57.1733 47.0736 57.84C47.9403 58.4933 48.4936 59.4 48.7336 60.56H46.0336C45.9003 60.08 45.6336 59.7067 45.2336 59.44C44.8469 59.16 44.3869 59.02 43.8536 59.02C43.1469 59.02 42.5469 59.2867 42.0536 59.82C41.5603 60.3533 41.3136 61.0933 41.3136 62.04C41.3136 62.9867 41.5603 63.7267 42.0536 64.26C42.5469 64.7933 43.1469 65.06 43.8536 65.06C44.3869 65.06 44.8469 64.9267 45.2336 64.66C45.6336 64.3933 45.9003 64.0133 46.0336 63.52H48.7336C48.4936 64.64 47.9403 65.54 47.0736 66.22C46.2069 66.9 45.1403 67.24 43.8736 67.24ZM50.7858 67V52.6H53.3458V58.6C53.6791 58.0533 54.1258 57.6267 54.6858 57.32C55.2591 57 55.9124 56.84 56.6458 56.84C57.8724 56.84 58.8191 57.2267 59.4858 58C60.1658 58.7733 60.5058 59.9067 60.5058 61.4V67H57.9658V61.64C57.9658 60.7867 57.7924 60.1333 57.4458 59.68C57.1124 59.2267 56.5791 59 55.8458 59C55.1258 59 54.5258 59.2533 54.0458 59.76C53.5791 60.2667 53.3458 60.9733 53.3458 61.88V67H50.7858ZM67.4938 67.24C66.5338 67.24 65.6671 67.02 64.8938 66.58C64.1338 66.14 63.5271 65.5333 63.0738 64.76C62.6338 63.9733 62.4138 63.0667 62.4138 62.04C62.4138 61.0133 62.6404 60.1133 63.0938 59.34C63.5471 58.5533 64.1538 57.94 64.9138 57.5C65.6871 57.06 66.5538 56.84 67.5138 56.84C68.4604 56.84 69.3138 57.06 70.0738 57.5C70.8471 57.94 71.4538 58.5533 71.8938 59.34C72.3471 60.1133 72.5738 61.0133 72.5738 62.04C72.5738 63.0667 72.3471 63.9733 71.8938 64.76C71.4538 65.5333 70.8471 66.14 70.0738 66.58C69.3004 67.02 68.4404 67.24 67.4938 67.24ZM67.4938 65.02C68.1604 65.02 68.7404 64.7733 69.2338 64.28C69.7271 63.7733 69.9738 63.0267 69.9738 62.04C69.9738 61.0533 69.7271 60.3133 69.2338 59.82C68.7404 59.3133 68.1671 59.06 67.5138 59.06C66.8338 59.06 66.2471 59.3133 65.7538 59.82C65.2738 60.3133 65.0338 61.0533 65.0338 62.04C65.0338 63.0267 65.2738 63.7733 65.7538 64.28C66.2471 64.7733 66.8271 65.02 67.4938 65.02ZM79.4027 67.24C78.4427 67.24 77.576 67.02 76.8027 66.58C76.0427 66.14 75.436 65.5333 74.9827 64.76C74.5427 63.9733 74.3227 63.0667 74.3227 62.04C74.3227 61.0133 74.5493 60.1133 75.0027 59.34C75.456 58.5533 76.0627 57.94 76.8227 57.5C77.596 57.06 78.4627 56.84 79.4227 56.84C80.3693 56.84 81.2227 57.06 81.9827 57.5C82.756 57.94 83.3627 58.5533 83.8027 59.34C84.256 60.1133 84.4827 61.0133 84.4827 62.04C84.4827 63.0667 84.256 63.9733 83.8027 64.76C83.3627 65.5333 82.756 66.14 81.9827 66.58C81.2093 67.02 80.3493 67.24 79.4027 67.24ZM79.4027 65.02C80.0693 65.02 80.6493 64.7733 81.1427 64.28C81.636 63.7733 81.8827 63.0267 81.8827 62.04C81.8827 61.0533 81.636 60.3133 81.1427 59.82C80.6493 59.3133 80.076 59.06 79.4227 59.06C78.7427 59.06 78.156 59.3133 77.6627 59.82C77.1827 60.3133 76.9427 61.0533 76.9427 62.04C76.9427 63.0267 77.1827 63.7733 77.6627 64.28C78.156 64.7733 78.736 65.02 79.4027 65.02ZM86.5516 67V52.6H89.1116V67H86.5516Z",
    fill: "#FFB900"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M37.088 96.336C35.128 96.336 33.4107 95.9067 31.936 95.048C30.48 94.1893 29.332 93.004 28.492 91.492C27.6707 89.9613 27.26 88.1973 27.26 86.2C27.26 84.2027 27.6707 82.448 28.492 80.936C29.332 79.4053 30.48 78.2107 31.936 77.352C33.4107 76.4933 35.128 76.064 37.088 76.064C39.0293 76.064 40.7373 76.4933 42.212 77.352C43.6867 78.2107 44.8347 79.4053 45.656 80.936C46.4773 82.448 46.888 84.2027 46.888 86.2C46.888 88.1973 46.4773 89.9613 45.656 91.492C44.8347 93.004 43.6867 94.1893 42.212 95.048C40.7373 95.9067 39.0293 96.336 37.088 96.336ZM37.088 93.116C38.9547 93.116 40.4387 92.5 41.54 91.268C42.66 90.036 43.22 88.3467 43.22 86.2C43.22 84.0533 42.66 82.364 41.54 81.132C40.4387 79.9 38.9547 79.284 37.088 79.284C35.2213 79.284 33.728 79.9 32.608 81.132C31.488 82.364 30.928 84.0533 30.928 86.2C30.928 88.3467 31.488 90.036 32.608 91.268C33.728 92.5 35.2213 93.116 37.088 93.116ZM49.6604 102.16V82.112H52.8524L53.2444 84.1C53.6924 83.484 54.2804 82.9427 55.0084 82.476C55.7551 82.0093 56.7164 81.776 57.8924 81.776C59.1991 81.776 60.3658 82.0933 61.3924 82.728C62.4191 83.3627 63.2311 84.2307 63.8284 85.332C64.4258 86.4333 64.7244 87.684 64.7244 89.084C64.7244 90.484 64.4258 91.7347 63.8284 92.836C63.2311 93.9187 62.4191 94.7773 61.3924 95.412C60.3658 96.028 59.1991 96.336 57.8924 96.336C56.8471 96.336 55.9324 96.14 55.1484 95.748C54.3644 95.356 53.7298 94.8053 53.2444 94.096V102.16H49.6604ZM57.1364 93.2C58.2751 93.2 59.2178 92.8173 59.9644 92.052C60.7111 91.2867 61.0844 90.2973 61.0844 89.084C61.0844 87.8707 60.7111 86.872 59.9644 86.088C59.2178 85.304 58.2751 84.912 57.1364 84.912C55.9791 84.912 55.0271 85.304 54.2804 86.088C53.5524 86.8533 53.1884 87.8427 53.1884 89.056C53.1884 90.2693 53.5524 91.268 54.2804 92.052C55.0271 92.8173 55.9791 93.2 57.1364 93.2ZM74.3661 96.336C72.9661 96.336 71.7247 96.0373 70.6421 95.44C69.5594 94.8427 68.7101 94.0027 68.0941 92.92C67.4781 91.8373 67.1701 90.5867 67.1701 89.168C67.1701 87.7307 67.4687 86.452 68.0661 85.332C68.6821 84.212 69.5221 83.344 70.5861 82.728C71.6687 82.0933 72.9381 81.776 74.3941 81.776C75.7567 81.776 76.9607 82.0747 78.0061 82.672C79.0514 83.2693 79.8634 84.0907 80.4421 85.136C81.0394 86.1627 81.3381 87.3107 81.3381 88.58C81.3381 88.7853 81.3287 89 81.3101 89.224C81.3101 89.448 81.3007 89.6813 81.2821 89.924H70.7261C70.8007 91.0067 71.1741 91.856 71.8461 92.472C72.5367 93.088 73.3674 93.396 74.3381 93.396C75.0661 93.396 75.6727 93.2373 76.1581 92.92C76.6621 92.584 77.0354 92.1547 77.2781 91.632H80.9181C80.6567 92.5093 80.2181 93.312 79.6021 94.04C79.0047 94.7493 78.2581 95.3093 77.3621 95.72C76.4847 96.1307 75.4861 96.336 74.3661 96.336ZM74.3941 84.688C73.5167 84.688 72.7421 84.94 72.0701 85.444C71.3981 85.9293 70.9687 86.676 70.7821 87.684H77.6981C77.6421 86.7693 77.3061 86.0413 76.6901 85.5C76.0741 84.9587 75.3087 84.688 74.3941 84.688ZM84.0444 96V82.112H87.2364L87.5724 84.716C88.0764 83.82 88.7578 83.1107 89.6164 82.588C90.4938 82.0467 91.5204 81.776 92.6964 81.776V85.556H91.6884C90.9044 85.556 90.2044 85.6773 89.5884 85.92C88.9724 86.1627 88.4871 86.5827 88.1324 87.18C87.7964 87.7773 87.6284 88.608 87.6284 89.672V96H84.0444ZM99.626 96.336C98.4313 96.336 97.4513 96.1493 96.686 95.776C95.9207 95.384 95.3513 94.8707 94.978 94.236C94.6047 93.6013 94.418 92.9013 94.418 92.136C94.418 90.848 94.922 89.8027 95.93 89C96.938 88.1973 98.45 87.796 100.466 87.796H103.994V87.46C103.994 86.508 103.723 85.808 103.182 85.36C102.641 84.912 101.969 84.688 101.166 84.688C100.438 84.688 99.8033 84.8653 99.262 85.22C98.7207 85.556 98.3847 86.06 98.254 86.732H94.754C94.8473 85.724 95.1833 84.8467 95.762 84.1C96.3593 83.3533 97.1247 82.784 98.058 82.392C98.9913 81.9813 100.037 81.776 101.194 81.776C103.173 81.776 104.731 82.2707 105.87 83.26C107.009 84.2493 107.578 85.6493 107.578 87.46V96H104.526L104.19 93.76C103.779 94.5067 103.201 95.1227 102.454 95.608C101.726 96.0933 100.783 96.336 99.626 96.336ZM100.438 93.536C101.465 93.536 102.258 93.2 102.818 92.528C103.397 91.856 103.761 91.0253 103.91 90.036H100.858C99.906 90.036 99.2247 90.2133 98.814 90.568C98.4033 90.904 98.198 91.324 98.198 91.828C98.198 92.3693 98.4033 92.7893 98.814 93.088C99.2247 93.3867 99.766 93.536 100.438 93.536ZM116.687 96C115.231 96 114.064 95.6453 113.187 94.936C112.309 94.2267 111.871 92.9667 111.871 91.156V85.108H109.491V82.112H111.871L112.291 78.388H115.455V82.112H119.207V85.108H115.455V91.184C115.455 91.856 115.595 92.3227 115.875 92.584C116.173 92.8267 116.677 92.948 117.387 92.948H119.123V96H116.687ZM123.908 79.956C123.255 79.956 122.713 79.76 122.284 79.368C121.873 78.976 121.668 78.4813 121.668 77.884C121.668 77.2867 121.873 76.8013 122.284 76.428C122.713 76.036 123.255 75.84 123.908 75.84C124.561 75.84 125.093 76.036 125.504 76.428C125.933 76.8013 126.148 77.2867 126.148 77.884C126.148 78.4813 125.933 78.976 125.504 79.368C125.093 79.76 124.561 79.956 123.908 79.956ZM122.116 96V82.112H125.7V96H122.116ZM129.133 96V82.112H132.297L132.577 84.464C133.006 83.6427 133.622 82.9893 134.425 82.504C135.246 82.0187 136.207 81.776 137.309 81.776C139.026 81.776 140.361 82.3173 141.313 83.4C142.265 84.4827 142.741 86.0693 142.741 88.16V96H139.157V88.496C139.157 87.3013 138.914 86.3867 138.429 85.752C137.943 85.1173 137.187 84.8 136.161 84.8C135.153 84.8 134.322 85.1547 133.669 85.864C133.034 86.5733 132.717 87.5627 132.717 88.832V96H129.133ZM151.74 91.856C151.068 91.856 150.443 91.7813 149.864 91.632L148.828 92.668C149.145 92.836 149.575 92.976 150.116 93.088C150.657 93.2 151.535 93.312 152.748 93.424C154.596 93.592 155.94 94.0307 156.78 94.74C157.62 95.4493 158.04 96.4293 158.04 97.68C158.04 98.5013 157.816 99.276 157.368 100.004C156.92 100.751 156.229 101.348 155.296 101.796C154.363 102.263 153.168 102.496 151.712 102.496C149.733 102.496 148.137 102.123 146.924 101.376C145.711 100.648 145.104 99.5467 145.104 98.072C145.104 96.8213 145.711 95.7387 146.924 94.824C146.551 94.656 146.224 94.4787 145.944 94.292C145.683 94.1053 145.449 93.9093 145.244 93.704V93.06L147.68 90.484C146.597 89.532 146.056 88.3093 146.056 86.816C146.056 85.8827 146.28 85.0333 146.728 84.268C147.195 83.5027 147.848 82.896 148.688 82.448C149.528 82 150.545 81.776 151.74 81.776C152.524 81.776 153.252 81.888 153.924 82.112H159.188V84.296L156.808 84.464C157.181 85.1733 157.368 85.9573 157.368 86.816C157.368 87.7493 157.144 88.5987 156.696 89.364C156.248 90.1293 155.595 90.736 154.736 91.184C153.896 91.632 152.897 91.856 151.74 91.856ZM151.74 89.112C152.468 89.112 153.065 88.916 153.532 88.524C154.017 88.132 154.26 87.572 154.26 86.844C154.26 86.116 154.017 85.556 153.532 85.164C153.065 84.772 152.468 84.576 151.74 84.576C150.975 84.576 150.359 84.772 149.892 85.164C149.425 85.556 149.192 86.116 149.192 86.844C149.192 87.572 149.425 88.132 149.892 88.524C150.359 88.916 150.975 89.112 151.74 89.112ZM148.38 97.708C148.38 98.3987 148.697 98.912 149.332 99.248C149.985 99.6027 150.779 99.78 151.712 99.78C152.608 99.78 153.336 99.5933 153.896 99.22C154.456 98.8653 154.736 98.38 154.736 97.764C154.736 97.26 154.549 96.84 154.176 96.504C153.821 96.168 153.103 95.9627 152.02 95.888C151.255 95.832 150.545 95.748 149.892 95.636C149.351 95.9347 148.959 96.2613 148.716 96.616C148.492 96.9707 148.38 97.3347 148.38 97.708ZM34.596 126.336C33.1587 126.336 31.8893 126.093 30.788 125.608C29.6867 125.104 28.8187 124.395 28.184 123.48C27.5493 122.547 27.2227 121.417 27.204 120.092H30.984C31.0213 121.007 31.348 121.781 31.964 122.416C32.5987 123.032 33.4667 123.34 34.568 123.34C35.52 123.34 36.276 123.116 36.836 122.668C37.396 122.201 37.676 121.585 37.676 120.82C37.676 120.017 37.424 119.392 36.92 118.944C36.4347 118.496 35.7813 118.132 34.96 117.852C34.1387 117.572 33.2613 117.273 32.328 116.956C30.816 116.433 29.6587 115.761 28.856 114.94C28.072 114.119 27.68 113.027 27.68 111.664C27.6613 110.507 27.932 109.517 28.492 108.696C29.0707 107.856 29.8547 107.212 30.844 106.764C31.8333 106.297 32.972 106.064 34.26 106.064C35.5667 106.064 36.7147 106.297 37.704 106.764C38.712 107.231 39.496 107.884 40.056 108.724C40.6347 109.564 40.9427 110.563 40.98 111.72H37.144C37.1253 111.029 36.8547 110.423 36.332 109.9C35.828 109.359 35.1187 109.088 34.204 109.088C33.42 109.069 32.7573 109.265 32.216 109.676C31.6933 110.068 31.432 110.647 31.432 111.412C31.432 112.065 31.6373 112.588 32.048 112.98C32.4587 113.353 33.0187 113.671 33.728 113.932C34.4373 114.193 35.2493 114.473 36.164 114.772C37.1347 115.108 38.0213 115.5 38.824 115.948C39.6267 116.396 40.2707 116.993 40.756 117.74C41.2413 118.468 41.484 119.411 41.484 120.568C41.484 121.595 41.2227 122.547 40.7 123.424C40.1773 124.301 39.4027 125.011 38.376 125.552C37.3493 126.075 36.0893 126.336 34.596 126.336ZM45.955 132.16L49.175 125.076H48.335L42.931 112.112H46.823L50.715 121.884L54.775 112.112H58.583L49.763 132.16H45.955ZM65.6745 126.336C64.4425 126.336 63.3598 126.14 62.4265 125.748C61.4931 125.337 60.7465 124.777 60.1865 124.068C59.6265 123.359 59.2905 122.537 59.1785 121.604H62.7905C62.9025 122.145 63.2011 122.612 63.6865 123.004C64.1905 123.377 64.8345 123.564 65.6185 123.564C66.4025 123.564 66.9718 123.405 67.3265 123.088C67.6998 122.771 67.8865 122.407 67.8865 121.996C67.8865 121.399 67.6251 120.997 67.1025 120.792C66.5798 120.568 65.8518 120.353 64.9185 120.148C64.3211 120.017 63.7145 119.859 63.0985 119.672C62.4825 119.485 61.9131 119.252 61.3905 118.972C60.8865 118.673 60.4758 118.3 60.1585 117.852C59.8411 117.385 59.6825 116.816 59.6825 116.144C59.6825 114.912 60.1678 113.876 61.1385 113.036C62.1278 112.196 63.5091 111.776 65.2825 111.776C66.9251 111.776 68.2318 112.159 69.2025 112.924C70.1918 113.689 70.7798 114.744 70.9665 116.088H67.5785C67.3731 115.061 66.5985 114.548 65.2545 114.548C64.5825 114.548 64.0598 114.679 63.6865 114.94C63.3318 115.201 63.1545 115.528 63.1545 115.92C63.1545 116.331 63.4251 116.657 63.9665 116.9C64.5078 117.143 65.2265 117.367 66.1225 117.572C67.0931 117.796 67.9798 118.048 68.7825 118.328C69.6038 118.589 70.2571 118.991 70.7425 119.532C71.2278 120.055 71.4705 120.811 71.4705 121.8C71.4891 122.659 71.2651 123.433 70.7985 124.124C70.3318 124.815 69.6598 125.356 68.7825 125.748C67.9051 126.14 66.8691 126.336 65.6745 126.336ZM80.0879 126C78.6319 126 77.4652 125.645 76.5879 124.936C75.7106 124.227 75.2719 122.967 75.2719 121.156V115.108H72.8919V112.112H75.2719L75.6919 108.388H78.8559V112.112H82.6079V115.108H78.8559V121.184C78.8559 121.856 78.9959 122.323 79.2759 122.584C79.5746 122.827 80.0786 122.948 80.7879 122.948H82.5239V126H80.0879ZM91.7696 126.336C90.3696 126.336 89.1283 126.037 88.0456 125.44C86.9629 124.843 86.1136 124.003 85.4976 122.92C84.8816 121.837 84.5736 120.587 84.5736 119.168C84.5736 117.731 84.8723 116.452 85.4696 115.332C86.0856 114.212 86.9256 113.344 87.9896 112.728C89.0723 112.093 90.3416 111.776 91.7976 111.776C93.1603 111.776 94.3643 112.075 95.4096 112.672C96.4549 113.269 97.2669 114.091 97.8456 115.136C98.4429 116.163 98.7416 117.311 98.7416 118.58C98.7416 118.785 98.7323 119 98.7136 119.224C98.7136 119.448 98.7043 119.681 98.6856 119.924H88.1296C88.2043 121.007 88.5776 121.856 89.2496 122.472C89.9403 123.088 90.7709 123.396 91.7416 123.396C92.4696 123.396 93.0763 123.237 93.5616 122.92C94.0656 122.584 94.4389 122.155 94.6816 121.632H98.3216C98.0603 122.509 97.6216 123.312 97.0056 124.04C96.4083 124.749 95.6616 125.309 94.7656 125.72C93.8883 126.131 92.8896 126.336 91.7696 126.336ZM91.7976 114.688C90.9203 114.688 90.1456 114.94 89.4736 115.444C88.8016 115.929 88.3723 116.676 88.1856 117.684H95.1016C95.0456 116.769 94.7096 116.041 94.0936 115.5C93.4776 114.959 92.7123 114.688 91.7976 114.688ZM101.448 126V112.112H104.612L104.92 113.988C105.368 113.316 105.956 112.784 106.684 112.392C107.431 111.981 108.289 111.776 109.26 111.776C111.407 111.776 112.928 112.607 113.824 114.268C114.328 113.503 115 112.896 115.84 112.448C116.699 112 117.632 111.776 118.64 111.776C120.451 111.776 121.841 112.317 122.812 113.4C123.783 114.483 124.268 116.069 124.268 118.16V126H120.684V118.496C120.684 117.301 120.451 116.387 119.984 115.752C119.536 115.117 118.836 114.8 117.884 114.8C116.913 114.8 116.129 115.155 115.532 115.864C114.953 116.573 114.664 117.563 114.664 118.832V126H111.08V118.496C111.08 117.301 110.847 116.387 110.38 115.752C109.913 115.117 109.195 114.8 108.224 114.8C107.272 114.8 106.497 115.155 105.9 115.864C105.321 116.573 105.032 117.563 105.032 118.832V126H101.448Z",
    fill: "#FFB900"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M66.401 26.2779L67.8546 25.815L66.622 22.0973L69.1637 21.2885L68.6914 19.8636L64.6961 21.1364L66.401 26.279V26.2779ZM56.8814 16.9355L57.3537 15.5106L61.1464 16.7188L62.379 13L63.8327 13.4629L62.1279 18.6054L56.8814 16.9344V16.9355ZM65.9322 26.5059L64.695 27.3874L62.3513 24.2245L56.7449 27.6676L52.6153 30.4573L56.8479 24.2233L58.9659 20.8993L55.7391 18.602L56.6384 17.3893L61.1013 20.5681L57.1095 26.051L62.6881 22.1302L65.9311 26.5048L65.9322 26.5059Z",
    fill: "white"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5538 13.5604H67.0306C67.394 13.5604 67.7239 13.6047 68.0213 13.6943C68.3188 13.7828 68.5711 13.9133 68.7806 14.0823C68.99 14.2525 69.1509 14.4612 69.2632 14.7097C69.3755 14.9581 69.4322 15.2383 69.4322 15.5514V15.5673C69.4322 15.902 69.3697 16.1958 69.247 16.4488C69.1231 16.7029 68.9507 16.9151 68.7308 17.0875C68.5109 17.2599 68.2482 17.3893 67.9426 17.4755C67.6371 17.5617 67.306 17.6048 66.9484 17.6048H66.1556V19.2237H64.5538V13.5604ZM66.9149 16.3762C67.2007 16.3762 67.4253 16.3104 67.5873 16.1765C67.7493 16.0438 67.8303 15.8634 67.8303 15.6354V15.6195C67.8303 15.3756 67.7493 15.1895 67.5873 15.0625C67.4253 14.9354 67.1973 14.8707 66.9067 14.8707H66.1556V16.3762H66.9149Z",
    fill: "white"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M26 30.6978H31.2731C32.0462 30.6978 32.7499 30.7919 33.383 30.9825C34.0161 31.172 34.5543 31.4477 34.9999 31.8096C35.4454 32.1715 35.788 32.6173 36.0276 33.1448C36.2672 33.6735 36.3876 34.2702 36.3876 34.9362V34.9702C36.3876 35.6827 36.2556 36.3089 35.9917 36.8478C35.7279 37.3878 35.3621 37.8416 34.8934 38.2091C34.4246 38.5767 33.8656 38.8524 33.2152 39.0362C32.5647 39.2199 31.8587 39.3118 31.0971 39.3118H29.4097V42.7584H26V30.6966V30.6978ZM31.0277 36.6935C31.6365 36.6935 32.1145 36.5517 32.4605 36.2692C32.8066 35.9867 32.9791 35.6021 32.9791 35.1165V35.0814C32.9791 34.5618 32.8054 34.1659 32.4605 33.8947C32.1145 33.6236 31.6319 33.4874 31.0103 33.4874H29.4108V36.6923H31.0277V36.6935Z",
    fill: "white"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8297 30.6978H43.6479C44.5969 30.6978 45.4002 30.8124 46.0564 31.0427C46.7126 31.273 47.2462 31.594 47.6559 32.007C48.3827 32.6967 48.7462 33.6327 48.7462 34.8159V34.8499C48.7462 35.7802 48.5182 36.5505 48.061 37.1586C47.6038 37.7678 46.9892 38.2329 46.215 38.554L49.1501 42.7584H45.2127L42.7347 39.1054H41.2405V42.7584H37.8308V30.6966L37.8297 30.6978ZM43.4905 36.487C44.0761 36.487 44.5275 36.3577 44.8434 36.099C45.1594 35.8403 45.318 35.4932 45.318 35.0564V35.0224C45.318 34.5402 45.1536 34.1806 44.8261 33.9458C44.4974 33.7109 44.0472 33.593 43.4731 33.593H41.2405V36.4881H43.4905V36.487Z",
    fill: "white"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6558 43C55.7067 43 54.8271 42.8366 54.0192 42.5088C53.2114 42.1809 52.5135 41.7362 51.9278 41.1735C51.3422 40.6108 50.8815 39.9505 50.5482 39.1916C50.2137 38.4337 50.0471 37.6237 50.0471 36.7627V36.7286C50.0471 35.8676 50.2137 35.0542 50.5482 34.2907C50.8827 33.5272 51.348 32.8601 51.9452 32.2917C52.5424 31.7233 53.2461 31.2752 54.0551 30.9474C54.8641 30.6195 55.7426 30.4561 56.6916 30.4561C57.6407 30.4561 58.5203 30.6195 59.3282 30.9474C60.1372 31.2752 60.8339 31.7199 61.4196 32.2826C62.0052 32.8453 62.4659 33.5056 62.7992 34.2646C63.1325 35.0235 63.3003 35.8324 63.3003 36.6935V36.7275C63.3003 37.5886 63.1337 38.402 62.7992 39.1655C62.4647 39.9301 61.9994 40.5961 61.4022 41.1644C60.805 41.7328 60.1013 42.1809 59.2923 42.5088C58.4833 42.8366 57.6048 43 56.6558 43ZM56.6824 39.9846C57.1523 39.9846 57.5817 39.8984 57.9694 39.7259C58.3571 39.5535 58.6858 39.3209 58.9566 39.0282C59.2263 38.7355 59.4381 38.394 59.5909 38.0026C59.7437 37.6124 59.8201 37.1983 59.8201 36.7627V36.7286C59.8201 36.2919 59.7437 35.8789 59.5909 35.4875C59.4381 35.0973 59.2205 34.7524 58.9393 34.454C58.6569 34.1556 58.3224 33.9174 57.9347 33.7393C57.5469 33.5612 57.1176 33.4727 56.6477 33.4727C56.1778 33.4727 55.7518 33.5589 55.3699 33.7314C54.988 33.9038 54.6593 34.1364 54.3826 34.4291C54.106 34.7218 53.8954 35.0644 53.7484 35.4546C53.6014 35.8449 53.5285 36.259 53.5285 36.6946V36.7286C53.5285 37.1654 53.6049 37.5784 53.7577 37.9686C53.9104 38.3589 54.1245 38.7038 54.4012 39.0021C54.6766 39.3005 55.0088 39.5387 55.3965 39.7168C55.7842 39.8949 56.2136 39.9834 56.6835 39.9834L56.6824 39.9846Z",
    fill: "white"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0758 30.6978H70.3488C71.122 30.6978 71.8256 30.7919 72.4587 30.9825C73.0918 31.1731 73.63 31.4477 74.0756 31.8096C74.5212 32.1715 74.8638 32.6173 75.1034 33.1448C75.343 33.6735 75.4633 34.2702 75.4633 34.9362V34.9702C75.4633 35.6827 75.3314 36.3089 75.0675 36.8478C74.8036 37.3878 74.4379 37.8416 73.9691 38.2091C73.5004 38.5767 72.9414 38.8524 72.2909 39.0362C71.6405 39.2199 70.9345 39.3118 70.1729 39.3118H68.4854V42.7584H65.0758V30.6966V30.6978ZM70.1035 36.6935C70.7122 36.6935 71.1902 36.5517 71.5363 36.2692C71.8824 35.9867 72.0548 35.6021 72.0548 35.1165V35.0814C72.0548 34.5618 71.8812 34.1659 71.5363 33.8947C71.1902 33.6236 70.7065 33.4874 70.0861 33.4874H68.4866V36.6923H70.1035V36.6935Z",
    fill: "white"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9066 30.6978H86.7861V33.5408H80.2642V35.3673H86.1703V38.0038H80.2642V39.9165H86.874V42.7595H76.9066V30.6978Z",
    fill: "white"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6309 30.6978H92.0406V39.8303H98V42.7595H88.6309V30.6978Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_11046_1165)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 148,
    width: 48,
    height: 28,
    rx: 14,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 148,
    width: 48,
    height: 28,
    rx: 14,
    fill: "url(#paint72_linear_11046_1165)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 148,
    width: 48,
    height: 28,
    rx: 14,
    fill: "url(#paint73_linear_11046_1165)"
  }))), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6979 166.899C51.3941 166.595 51.3941 166.105 51.6979 165.802L54.7124 162.776H42.8958C42.4674 162.776 42.1168 162.426 42.1168 161.999C42.1168 161.571 42.4674 161.221 42.8958 161.221H54.7124L51.6901 158.203C51.3863 157.9 51.3863 157.41 51.6901 157.106C51.9939 156.803 52.4846 156.803 52.7884 157.106L57.1505 161.454C57.4543 161.758 57.4543 162.248 57.1505 162.551L52.7962 166.899C52.4924 167.194 51.9939 167.194 51.6979 166.899Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11046_1165",
    x: 0,
    y: 0,
    width: 386,
    height: 198,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11046_1165"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11046_1165",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_11046_1165",
    x: 18,
    y: 140,
    width: 64,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11046_1165"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11046_1165",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11046_1165",
    x1: 268.192,
    y1: 70,
    x2: 268.192,
    y2: 180.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9CBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#D5C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C9BBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDB0B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11046_1165",
    x1: 268.192,
    y1: 165.952,
    x2: 268.192,
    y2: 198.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11046_1165",
    x1: 268.358,
    y1: 72.2656,
    x2: 268.358,
    y2: 163.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#71C6C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#4AA1AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11046_1165",
    x1: 242.855,
    y1: 70.566,
    x2: 291.01,
    y2: 82.4632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B7591"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#086998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_11046_1165",
    x1: 206.597,
    y1: 105.507,
    x2: 206.597,
    y2: 121.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56ACB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_11046_1165",
    x1: 208.89,
    y1: 132.479,
    x2: 208.89,
    y2: 148.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_11046_1165",
    x1: 208.89,
    y1: 142.677,
    x2: 208.89,
    y2: 158.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_11046_1165",
    x1: 221.354,
    y1: 132.479,
    x2: 221.354,
    y2: 148.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_11046_1165",
    x1: 221.354,
    y1: 142.677,
    x2: 221.354,
    y2: 158.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_11046_1165",
    x1: 233.817,
    y1: 132.479,
    x2: 233.817,
    y2: 148.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_11046_1165",
    x1: 233.817,
    y1: 142.677,
    x2: 233.817,
    y2: 158.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_11046_1165",
    x1: 256.479,
    y1: 132.479,
    x2: 256.479,
    y2: 148.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_11046_1165",
    x1: 256.479,
    y1: 142.677,
    x2: 256.479,
    y2: 158.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_11046_1165",
    x1: 268.942,
    y1: 132.479,
    x2: 268.942,
    y2: 148.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_11046_1165",
    x1: 268.942,
    y1: 142.677,
    x2: 268.942,
    y2: 158.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_11046_1165",
    x1: 281.406,
    y1: 132.479,
    x2: 281.406,
    y2: 148.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_11046_1165",
    x1: 281.406,
    y1: 142.677,
    x2: 281.406,
    y2: 158.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_11046_1165",
    x1: 302.934,
    y1: 133.614,
    x2: 302.934,
    y2: 149.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_11046_1165",
    x1: 302.934,
    y1: 143.811,
    x2: 302.934,
    y2: 159.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_11046_1165",
    x1: 315.398,
    y1: 133.614,
    x2: 315.398,
    y2: 149.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_11046_1165",
    x1: 315.398,
    y1: 143.811,
    x2: 315.398,
    y2: 159.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_11046_1165",
    x1: 327.861,
    y1: 133.614,
    x2: 327.861,
    y2: 149.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_11046_1165",
    x1: 327.861,
    y1: 143.811,
    x2: 327.861,
    y2: 159.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_11046_1165",
    x1: 254.185,
    y1: 104.374,
    x2: 254.185,
    y2: 120.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56ACB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_11046_1165",
    x1: 301.643,
    y1: 104.374,
    x2: 301.643,
    y2: 120.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56ACB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_11046_1165",
    x1: 316.503,
    y1: 72.8922,
    x2: 316.503,
    y2: 83.8629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#C5DF50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ADC74A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BF49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_11046_1165",
    x1: 327.835,
    y1: 74.9777,
    x2: 327.835,
    y2: 81.8618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_11046_1165",
    x1: 268.192,
    y1: 202.7,
    x2: 268.192,
    y2: 176.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_11046_1165",
    x1: 331.811,
    y1: 177.971,
    x2: 331.811,
    y2: 170.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#C5DF50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ADC74A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BF49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_11046_1165",
    x1: 380.111,
    y1: 130.857,
    x2: 380.111,
    y2: 222.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_11046_1165",
    x1: 286.048,
    y1: 113.528,
    x2: 286.048,
    y2: 146.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F99E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F3875F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_11046_1165",
    x1: 296.881,
    y1: 109.985,
    x2: 295.223,
    y2: 157.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F99E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F3875F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_11046_1165",
    x1: 288.529,
    y1: 109.678,
    x2: 286.929,
    y2: 155.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F99E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F3875F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_11046_1165",
    x1: 284.814,
    y1: 109.206,
    x2: 283.107,
    y2: 158.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F99E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F3875F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_11046_1165",
    x1: 307.862,
    y1: 131.722,
    x2: 307.862,
    y2: 197.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_11046_1165",
    x1: 346.657,
    y1: 131.508,
    x2: 346.699,
    y2: 212.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_11046_1165",
    x1: 356.636,
    y1: 78.7777,
    x2: 362.137,
    y2: 128.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC874E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C37441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#97522B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_11046_1165",
    x1: 355.006,
    y1: 139.143,
    x2: 356.109,
    y2: 115.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FA9E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F4885F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_11046_1165",
    x1: 355.111,
    y1: 136.875,
    x2: 355.941,
    y2: 118.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FA9E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F4885F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_11046_1165",
    x1: 348.826,
    y1: 85.2168,
    x2: 338.08,
    y2: 137.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB283"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAD7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FA9F73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F48960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_11046_1165",
    x1: 347.861,
    y1: 91.6818,
    x2: 349.492,
    y2: 147.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB283"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F99D71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F3845C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_11046_1165",
    x1: 351.83,
    y1: 80.8688,
    x2: 357.021,
    y2: 127.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC874E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C37441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#97522B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_11046_1165",
    x1: 344.832,
    y1: 81.6637,
    x2: 349.985,
    y2: 128.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC874E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C37441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#97522B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_11046_1165",
    x1: 347.922,
    y1: 130.713,
    x2: 347.922,
    y2: 157.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0444E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C41620"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_11046_1165",
    x1: 348.643,
    y1: 132.64,
    x2: 348.643,
    y2: 155.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0444E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C41620"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_11046_1165",
    x1: 348.642,
    y1: 133.721,
    x2: 348.642,
    y2: 150.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0444E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C41620"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_11046_1165",
    x1: 199.043,
    y1: 144.233,
    x2: 199.043,
    y2: 248.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_11046_1165",
    x1: 195.941,
    y1: 109.235,
    x2: 195.941,
    y2: 164.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC874E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C37441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#97522B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_11046_1165",
    x1: 221.049,
    y1: 165.011,
    x2: 221.049,
    y2: 243.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#568998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_11046_1165",
    x1: 160.182,
    y1: 165.18,
    x2: 160.182,
    y2: 240.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#568998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_11046_1165",
    x1: 201.179,
    y1: 185.493,
    x2: 201.179,
    y2: 263.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#568998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_11046_1165",
    x1: 194.39,
    y1: 185.311,
    x2: 194.39,
    y2: 253.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#568998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_11046_1165",
    x1: 239.729,
    y1: 128.042,
    x2: 219.9,
    y2: 170.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F99E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F3875F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_11046_1165",
    x1: 234.956,
    y1: 126.346,
    x2: 222.814,
    y2: 170.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F99E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F3875F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_11046_1165",
    x1: 213.47,
    y1: 142.097,
    x2: 213.47,
    y2: 193.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_11046_1165",
    x1: 204.988,
    y1: 107.796,
    x2: 208.237,
    y2: 167.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC874E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C37441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#97522B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_11046_1165",
    x1: 198.194,
    y1: 142.097,
    x2: 198.194,
    y2: 193.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_11046_1165",
    x1: 198.809,
    y1: 153.158,
    x2: 198.809,
    y2: 127.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FA9E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F4885F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_11046_1165",
    x1: 198.077,
    y1: 150.056,
    x2: 198.077,
    y2: 132.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FA9E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F4885F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_11046_1165",
    x1: 196.593,
    y1: 115.403,
    x2: 209.661,
    y2: 149.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FA9E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F4885F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_11046_1165",
    x1: 187.29,
    y1: 117.118,
    x2: 197.317,
    y2: 152.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FA9E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F4885F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_11046_1165",
    x1: 191.339,
    y1: 113.292,
    x2: 193.741,
    y2: 157.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC874E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C37441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#97522B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_11046_1165",
    x1: 193.008,
    y1: 108.453,
    x2: 196.238,
    y2: 167.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC874E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C37441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#97522B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_11046_1165",
    x1: 232.03,
    y1: 143.422,
    x2: 225.911,
    y2: 143.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_11046_1165",
    x1: 228.929,
    y1: 141.836,
    x2: 227.541,
    y2: 141.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9CBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#D5C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C9BBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDB0B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_11046_1165",
    x1: 211.625,
    y1: 179.132,
    x2: 216.327,
    y2: 207.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBE96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FDB991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FAAB84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F5946E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#EE7450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_11046_1165",
    x1: 214.347,
    y1: 187.006,
    x2: 176.752,
    y2: 131.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBE96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FDB991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FAAB84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F5946E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#EE7450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_11046_1165",
    x1: 203.277,
    y1: 178.542,
    x2: 208.598,
    y2: 210.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBE96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FDB991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FAAB84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F5946E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#EE7450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_11046_1165",
    x1: 191.961,
    y1: 142.097,
    x2: 191.961,
    y2: 193.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_11046_1165",
    x1: 241.331,
    y1: 192.105,
    x2: 210.78,
    y2: 192.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_11046_1165",
    x1: 210.869,
    y1: 192.192,
    x2: 193.662,
    y2: 192.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_11046_1165",
    x1: 227.106,
    y1: 191.083,
    x2: 224.999,
    y2: 191.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_11046_1165",
    x1: 74,
    y1: 176,
    x2: 23.5788,
    y2: 170.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_11046_1165",
    x1: 50,
    y1: 108.042,
    x2: 50,
    y2: 176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDA44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5F00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11046_1165"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 382,
    height: 194,
    rx: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSos);
export default __webpack_public_path__ + "static/media/SOS.7406cec7188acf8ab04b2c10b791100f.svg";
export { ForwardRef as ReactComponent };